import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	SimpleChanges
} from '@angular/core';

import { IHlsLevel } from '../hls/IHlsLevel';
import { IOnHlsLevelsChangedData } from '../hls/IOnHlsLevelsChangedData';

import styles from './HlsLevelPicker.module.less';

@Component({
	selector: 'hls-level-picker',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<label
			[ngClass]="styles.label"
			*ngFor="let player of hlsLevelsModel.players; index as $index; trackBy: playersTrackByFunc">
			{{ player.label }}

			<select
				[ngClass]="styles.select"
				(change)="onSelectChange($index)"
				[(ngModel)]="selectedLevels[$index]"
				ng-options="level as for level in player.levels">
				<option
					*ngFor="let level of player.levels; trackBy: levelsTrackByFunc"
					[ngValue]="level">
					{{ getLabelWithIndicator(level) }}
				</option>
			</select>
		</label>
	`,
    standalone: false
})
export class HlsLevelPickerComponent implements OnChanges {
	@Input() public hlsLevelsModel: IOnHlsLevelsChangedData;

	public selectedLevels: IHlsLevel[];
	public readonly styles = styles;

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.hlsLevelsModel && this.hlsLevelsModel) {
			this.selectedLevels = this.hlsLevelsModel.players
				.map(player => player.levels.find(level => level.isSelected));
		}
	}

	public getLabelWithIndicator(level: IHlsLevel): string {
		const indicator: string = level.isActive ? '*' : ' ';

		return indicator + level.label;
	}

	public levelsTrackByFunc(_index: number, level: IHlsLevel): number {
		return level.index;
	}

	public playersTrackByFunc(index: number): number {
		return index;
	}

	public onSelectChange(playerIndex: number): void {
		const selectedLevelIndex: number = this.selectedLevels[playerIndex].index;

		this.hlsLevelsModel.players[playerIndex].setLevel(selectedLevelIndex);
	}
}
